<template>
  <div class="pb_content">
    <div class="pb_content_body" style="height: 100%">
      <div class="body_student">
        <div class="student_head">
          <div
            class="return"
            @click.stop="
              goTo(
                '/index?userid=' +
                  userid +
                  '&oid=' +
                  oid +
                  '&cid=' +
                  classId +
                  '&tType=' +
                  tType +
                  '&screenType=' +
                  screenType
              )
            "
          >
            返回
            <!-- <img src="../assets/icon/return.png" alt="" /> -->
          </div>
          <div class="box_course">
            <div class="wheel">
              <img
                style="object-fit: cover"
                :src="
                  this.courseDetail.cover != null &&
                  this.courseDetail.cover != ''
                    ? JSON.parse(this.courseDetail.cover).length > 0
                      ? JSON.parse(this.courseDetail.cover)[0].url
                      : mr
                    : mr
                "
                alt
              />
            </div>
            <div class="right_box">
              <div class="rightT">
                <div class="right_box_title">{{ courseDetail.title }}</div>
                <div class="jd">{{ chapInfo.length }}阶段</div>
                <div class="jd">{{ rw }}任务</div>
              </div>
              <div class="cType">
                <div
                  class="all_choose"
                  v-for="(item, index) in courseType"
                  :key="index"
                >
                  <span style="color: #6c6c6c">{{ item + ":" }}</span>
                  <span
                    class="type_children"
                    v-for="(item2, index2) in courseTypeJson[item]"
                    :key="index2"
                    >{{ item2 }}</span
                  >
                </div>
              </div>
              <div class="cType" style="font-size: 18px; color: #6c6c6c">
                <div>
                  创建者:<span style="color: #000">{{
                    courseDetail.username
                  }}</span>
                </div>
                <div class="Tname" v-if="Tname.length > 0">
                  协同人员:<span
                    v-for="(tname, tIndex) in Tname"
                    :key="tIndex"
                    style="margin: 0 5px; color: #000"
                    >{{ tname }}</span
                  >
                </div>
              </div>
              <div class="people">
                <div class="man">
                  <img src="../assets/people.png" alt />
                </div>
                <div class="person">
                  {{ courseDetail.vcount != null ? courseDetail.vcount : 0 }}人
                </div>
              </div>

              <div class="now_study" @click="dialogVisible = true">
                立即学习
              </div>
            </div>
          </div>
        </div>
        <div class="student_body">
          <div class="sLeft" v-if="courseDetail.brief">
            <div class="courseT">项目详情</div>
            <div class="courseTd">{{ courseDetail.brief }}</div>
          </div>
          <div :class="courseDetail.brief != '' ? 'rightTd' : 'noBRight'">
            <div
              class="blue_box_one"
              v-for="(item, index) in chapInfo"
              :key="index"
              @click="addUserRate(index)"
            >
              <div>第{{ index + 1 }}阶段</div>
              <div :title="item.dyName">{{ item.dyName }}</div>
              <div>{{ item.chapterInfo[0].taskJson.length }}个任务</div>
            </div>
          </div>
        </div>

        <!-- <div
          style="
            text-align: center;
            padding: 30px 0 20px 0;
            box-sizing: border-box;
          "
        >
          此处滚动加载..
        </div>-->
        <el-dialog
          title="阶段选择"
          :visible.sync="dialogVisible"
          :append-to-body="true"
          width="700px"
          :before-close="handleClose"
          class="dialog_change"
        >
          <div style="font-size: 20px">请选择阶段</div>
          <div
            style="
              padding: 20px 30px;
              display: flex;
              flex-direction: row;
              flex-wrap: wrap;
            "
          >
            <div
              class="blue_box"
              v-for="(item, index) in chapInfo"
              :key="index"
              @click="addUserRate(index)"
            >
              <div>第{{ index + 1 }}阶段</div>
              <div>{{ item.dyName }}</div>
              <div>{{ item.chapterInfo[0].taskJson.length }}个任务</div>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      choose: 0,
      dialogVisible: false,
      id: this.$route.query.courseId,
      userid: this.$route.query.userid,
      oid: this.$route.query.oid,
      classId: this.$route.query.cid,
      tType: this.$route.query.tType,
      screenType: this.$route.query.screenType,
      courseDetail: {},
      aStudentName: [],
      chapInfo: [],
      courseType: [],
      Tname: [],
      courseTypeJson: {},
      userinfo: [],
      mr: require("../assets/icon/wheel.png"),
      rw:0,
    };
  },
  methods: {
    handleClose(done) {
      done();
    },
    goTo(path) {
      this.$router.push(path);
    },
    addUserRate(i) {
      // var suid = this.userid;
      // if (
      //   JSON.parse(this.courseDetail.course_student).indexOf(suid) == -1 &&
      //   JSON.parse(this.courseDetail.userid) != suid
      // ) {
      //   this.$message.error("你没有该权限");
      //   return;
      // }
      // var a =
      //   this.courseDetail.course_student != ""
      //     ? JSON.parse(this.courseDetail.course_student)
      //     : "";
      // if (this.courseDetail.userid != suid) {
      //   if (this.userinfo.type == 2) {
      //     if (a != "") {
      //       if (
      //         JSON.parse(this.courseDetail.course_student).indexOf(suid) == -1
      //       ) {
      //         this.$message.error("你没有该权限");
      //         return;
      //       }
      //     } else {
      //       this.$message.error("暂无项目学员，请联系老师添加项目学员!");
      //       return;
      //     }
      //   }
      // }
      let params = {
        uid: this.userid,
        cid: this.id,
      };
      this.ajax
        .get(this.$store.state.api + "addUserR", params)
        .then((res) => {
          console.log(res.data);
          this.updateVc();
          this.goTo(
            "/study?type=" +
              i +
              "&courseId=" +
              this.id +
              "&userid=" +
              this.userid +
              "&oid=" +
              this.oid +
              "&cid=" +
              this.classId +
              "&tType=" +
              this.tType +
              "&screenType=" +
              this.screenType
          );
        })
        .catch((err) => {
          console.error(err);
        });
    },
    updateVc() {
      let params = {
        cid: this.id,
      };
      this.ajax
        .get(this.$store.state.api + "updateVc", params)
        .then((res) => {
          console.log(res.data);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getCourseDetail() {
      const loading = this.$loading.service({
        background: "rgba(255, 255, 255, 0.7)",
        target: document.querySelector(".student_table"),
      });
      let params = {
        courseId: this.id,
      };
      this.ajax
        .get(this.$store.state.api + "selectCourseDetail", params)
        .then((res) => {
          loading.close();
          // this.total = res.data[0].length > 0 ? res.data[0][0].num : 0;
          this.courseDetail = res.data[0][0];
          var a = res.data[0];
          var b = res.data[1];
          var c = res.data[2];
          for (var i = 0; i < b.length; i++) {
            // if (!this.id) {
            //   this.courseType[b[i].id] = [];
            // }
            for (var j = 0; j < a.length; j++) {
              if (b[i].id == a[j].pid) {
                if (!this.courseTypeJson[b[i].name]) {
                  this.courseType.push(b[i].name);
                  this.courseTypeJson[b[i].name] = [];
                }
                this.courseTypeJson[b[i].name].push(a[j].name);
              }
            }
          }
          for (var k = 0; k < c.length; k++) {
            this.Tname.push(c[k].name);
          }
          console.log(this.courseTypeJson.length);
          this.aStudentName = res.data[2];
          this.chapInfo = JSON.parse(this.courseDetail.chapters);
          for(var z = 0;z<this.chapInfo.length;z++){
            this.rw += this.chapInfo[z].chapterInfo[0].taskJson.length;
          }
        })
        .catch((err) => {
          loading.close();
          console.error(err);
        });
    },
    getUser() {
      let params = { uid: this.userid };
      this.ajax
        .get(this.$store.state.api + "getUser", params)
        .then((res) => {
          this.userinfo = res.data[0][0];
        })
        .catch((err) => {
          console.error(err);
        });
    },
    // getSName() {
    // 	let params = {
    // 		uid: JSON.stringify(this.courseDetail.course_student),
    // 	};
    // 	this.ajax
    // 		.get(this.$store.state.api + "selectSName", params)
    // 		.then((res) => {
    // 			this.aStudentName = res.data[0];
    // 		})
    // 		.catch((err) => {
    // 			console.error(err);
    // 		});
    // },
  },
  created() {
    this.getCourseDetail();
    this.getUser();
    document.scrollingElement.scrollTop = 0;
    // this.getSName();
  },
};
</script>

<style scoped>
.body_student {
  margin: 10px auto;
  width: 98%;
  height: 100%;
}
.student_head {
  width: 100%;
  background: #fff;
  height: 30%;
  position: relative;
}
.wheel {
  width: 210px;
  max-height: 146px;
  display: flex;
  align-items: center;
}
.man {
  width: 16px;
  height: 16px;
}
.man > img {
  width: 100%;
  height: 100%;
}
.wheel > img {
  width: 100%;
}
.box_course {
  display: flex;
  padding: 25px 0 20px 60px;
}
.right_box {
  display: flex;
  flex-direction: column;
  margin-left: 30px;
  align-items: flex-start;
}
.right_box_title {
  font-size: 23px;
}
.people {
  display: flex;
  margin-top: 20px;
}
.person {
  margin-left: 10px;
  line-height: 18px;
}
.now_study {
  width: 150px;
  height: 35px;
  color: #fff;
  background: #4a9eed;
  text-align: center;
  line-height: 35px;
  border-radius: 5px;
  font-size: 13px;
  cursor: pointer;
  margin-top: 30px;
}
.choose_who {
  display: flex;
  margin: 15px 0 0 25px;
}
.who_choose {
  height: 28px;
  cursor: pointer;
}
.choose_who > div:nth-child(2) {
  margin-left: 35px;
}
.choose {
  border-bottom: 5px solid #4a9eed;
  color: #4a9eed;
}
.student_body {
  display: flex;
}
.student_body,
.right {
  width: 100%;
  margin: 10px auto;
  min-height: 688px;
}
.nav {
  margin: auto 25px;
  width: 80%;
  padding-top: 5px;
  text-indent: 25px;
}
.pic {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  height: 100%;
  justify-content: space-evenly;
}
.Img {
  /*width: 30%; */
  width: 300px;
  margin: 20px 50px;
  margin: 20px 10px;
  border: 1px solid #dbdbdb;
  border-radius: 5px;
  overflow: hidden;
}
.Img > img {
  width: 100%;
  height: 100%;
}
.student_body_one,
.right_one {
  width: 100%;
  margin: 0 auto;
  background: #fff;
  margin-top: 10px;
  min-height: 688px;
}
.student {
  width: 85%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin: auto 10px;
}
.student > div {
  width: 12%;
  height: 35px;
  background: #e3759a;
  text-align: center;
  border: 1px solid #e3759a;
  border-radius: 5px;
  color: #fff;
  line-height: 35px;
  margin: 10px;
}
.dialog_change >>> .el-dialog {
  border-radius: 5px;
}
.dialog_change >>> .el-dialog__header {
  background: #303030;
  height: 36px;
  line-height: 36px;
  padding-left: 10px;
  padding: 0px 10px 0px;
}
.dialog_change >>> .el-dialog__headerbtn {
  top: 10px !important;
  right: 10px !important;
}
.dialog_change >>> .el-dialog__title {
  color: #fff;
  font-size: 14px;
  line-height: 5px;
}
.dialog_change >>> .el-dialog__body {
  background: #f5f5f5;
}
.blue_box {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.blue_box,
.blue_box_one {
  width: 30%;
  height: 100px;
  text-align: center;
  color: #fff;
  background-image: linear-gradient(90deg, #477cd7, #65b9fc);
  border-radius: 15px;
  margin: 15px 0 15px 15px;
  cursor: pointer;
}
.blue_box_one {
  width: 200px;
  height: 200px;
  background-image: linear-gradient(90deg, #477cd7, #65b9fc);
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
}
.blue_box_one > div {
  margin: 5px 0;
}
.blue_box_one > div:nth-child(1) {
  font-size: 20px;
  font-weight: bold;
}
.blue_box > div:nth-child(2) {
  margin-top: 10px;
}

.blue_box_one > div:nth-child(2) {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  width: 100%;
  text-align: center;
  max-width: calc(100% - 85px);
  margin: 0 auto;
}
.return {
  background: #205cc6;
  width: 70px;
  height: 30px;
  color: #fff;
  text-align: center;
  line-height: 32px;
  margin-right: 20px;
  cursor: pointer;
  border-radius: 5px;
  position: absolute;
  right: 0;
  top: 24px;
  font-size: 14px;
}
.return > img {
  width: 100%;
  height: 100%;
}
.cType {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}
.cType > div > span {
  font-size: 18px;
}

.type_children + .type_children {
  margin-left: 10px;
}
.all_choose {
  margin-right: 10px;
  max-width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rightT {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}

.jd {
  background: #4a9eed;
  margin-left: 15px;
  border-radius: 10px;
  color: #fff;
  width: 70px;
  height: 25px;
  text-align: center;
  line-height: 25px;
}
.sLeft {
  width: 14%;
  margin-right: 10px;
  background: rgb(255, 255, 255);
  padding: 20px 0 0 25px;
  border-radius: 10px;
}
.courseT {
  border-left: 3px solid #2e66c9;
  padding-left: 5px;
  color: #2e66c9;
  font-weight: bold;
}
.courseTd {
  padding-top: 15px;
  width: 175px;
  height: 700px;
  overflow: auto;
  max-height: 715px;
  word-break: break-word;
}

.courseTd::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 6px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 6px;
}

/*定义滚动条轨道 内阴影+圆角*/
.courseTd::-webkit-scrollbar {
  border-radius: 10px;
  background-color: #eee;
}

/*定义滑块 内阴影+圆角*/
.courseTd::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: rgba(0, 0, 0, 0.1);
}
.rightTd,
.noBRight {
  width: 84%;
  background: #fff;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: flex-start;
  align-items: center;
  justify-content: flex-start;
}
.noBRight {
  width: 100%;
}
.Tname {
  margin-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/courseDetail.vue